import EnterpriseMetricCard from "../../../enterprise/components/EnterpriseMetricCard";

export default function ComplianceSummary({
  underReview = 0,
  actionRequired = 0,
  approved = 0,
  expiring = 0,
  ready = 0,
}) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit,minmax(170px,1fr))",
        gap: 10,
      }}
    >
      <EnterpriseMetricCard
        title="Under Review"
        value={underReview}
        subtitle="Awaiting review"
        color="primary"
      />

      <EnterpriseMetricCard
        title="Action Required"
        value={actionRequired}
        subtitle="Needs attention"
        color="danger"
      />

      <EnterpriseMetricCard
        title="Approved"
        value={approved}
        subtitle="Ready workers"
        color="success"
      />

      <EnterpriseMetricCard
        title="Expiring Soon"
        value={expiring}
        subtitle="30 days"
        color="warning"
      />

      <EnterpriseMetricCard
        title="Review Queue"
        value={ready}
        subtitle="Pending approvals"
        color="info"
      />
    </div>
  );
}